var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.todos),function(todo,index){return _c('div',{key:index,staticClass:"d-flex align-items-center py-2"},[_c('div',[_c('b-form-checkbox',{attrs:{"id":todo.id,"value":todo.id}},[_c('span',{staticClass:"text-dark font-weight-normal"},[_vm._v(_vm._s(todo.title))]),_c('span',{class:'badge bg-light-' +
            todo.tagcolor +
            ' text-' +
            todo.tagcolor +
            ' ml-2'},[_vm._v(_vm._s(todo.tag))])]),_c('div',{staticClass:"font-12 pl-4 text-muted d-inline-block"},[_vm._v(" "+_vm._s(todo.time)+" ")])],1)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }